import React, { createContext, useState } from "react";

export const SalesContext = createContext();

export const SalesProvider = ({ children }) => {
  const [salesDetailInfoFromContext, setSalesDetailInfoFromContext] = useState(
    []
  );
  return (
    <SalesContext.Provider
      value={{
        salesDetailInfoFromContext,
        setSalesDetailInfoFromContext,
      }}
    >
      {children}
    </SalesContext.Provider>
  );
};
